import React, { useState, useEffect } from 'react';
// import { TreeView, TreeItem } from '@mui/lab';
import { Checkbox, Typography } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import Box from '@mui/material/Box';
import { useSelector } from "react-redux";
import '../../cssfiles/homepage.css';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { getdevicetagsModified } from '../../Restclient/datacollection';
import MaterialUISwitch from '../CommonComponents/MaterialUISwitch';
import CustomDialogBox from '../CommonComponents/CustomDialogBox';

const renderTreeNodes = (node, handleCheck, checkedNode, devicename, deviceId,userdetails, showAlias) => {

  if(node.hasOwnProperty("TagID") && node.hasOwnProperty("Alias") && (node["ProjectID"]===userdetails.Projectid || userdetails.Projectid == "All")){
    console.log("renderTreeNodes node",node)  
    return (
          <TreeItem
              key={deviceId + node["TagID"]}
              itemId={deviceId + node["TagID"]}
              label={
                  <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis" }}>
                      <Checkbox checkedIcon={<CheckBoxOutlinedIcon />}  style={{color:'var(--SecondaryText)', color:"008CD7"}}
                          checked={checkedNode === deviceId + node["TagID"]}
                          sx={{
                            padding: 0,
                            margin: 0,
                            marginRight: '8px',
                            color: 'var(--HighlightedText_Stroke)',
                            '& .MuiSvgIcon-root': {
                                fontSize: '20px',
                                color: 'var(--HighlightedText_Stroke)'
                            }
                          }}
                          onChange={(event) => handleCheck(event, node, deviceId + node["TagID"],devicename,deviceId)}
                      />
                      <span style={{color:'var(--SecondaryText)'}}>{showAlias ? node["Alias"] : node["TagName"]}</span>
                  </Typography>
              }
              sx={{
                '& .MuiTreeItem-content':{
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-start'
                },
                '& .MuiTreeItem-label':{
                    fontSize:'16px',
                    fontWeight:400,
                    textAlign: 'left',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden'
                },
              }}
          >
          </TreeItem>
      );
  }
 
};

const AssetTagsRetrievalModified = ({ assetdata, setSelectedTag, selectedTag, setSelectedAsset, setExistingDeviceTagAlarmConfig, setShowAliasFlag = () => {} }) => {
        const [checkedNode, setCheckedNode] = useState(null); // Holds the id of the currently checked node
        // Uncheck when parent clears selectedTag
        useEffect(() => {
            console.log("AssetTagsRetrievalModified - selectedTag changed:", selectedTag);
            if (selectedTag === null) {
                setCheckedNode(null);
            }
        }, [selectedTag]);
    const [selectedCheckedNodeName, setSelectedCheckedNodeName] = useState(null); // Holds the name of the currently checked tree item
    const [showAlias, setShowAlias] = useState(true); // Toggle for showing Alias or TagName
    const overviewstate = useSelector((state) => state.mainpagedata.overviewbarstate);
    const [pagesize, setPagesize] = useState(480);
    const [anchorEl, setAnchorEl] = useState(null);
    const themechange = useSelector((state) => state.themedata.theme)
    const projectname = useSelector((state) => state.mainpagedata.selectedprojectname);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMsg, setDialogMsg] = useState("");
    const [blockedDeviceIndexes, setBlockedDeviceIndexes] = useState([]);

    useEffect(() => {
        if (overviewstate) {
            setPagesize(440);
        } else {
            setPagesize(380);
        }
      }, [overviewstate]);

    // Helper: find duplicate tag IDs within a device
    function hasDuplicateTagIds(tagdetails, deviceId) {
        const seen = new Set();
        const dups = new Set();
        tagdetails.forEach(tag => {
            if (tag.TagID) {
                const id = deviceId + tag.TagID;
                if (seen.has(id)) dups.add(tag.TagID);
                else seen.add(id);
            }
        });
        return Array.from(dups);
    }

    // Helper: find duplicate device IDs
    function findDuplicateDeviceIds(devices) {
        const seen = new Set();
        const dups = new Set();
        if (devices.length > 0) {
            devices.forEach(device => {
                if (device.DeviceID) {
                    if (seen.has(device.DeviceID)) dups.add(device.DeviceID);
                    else seen.add(device.DeviceID);
                }
            });
        }
        return Array.from(dups);
    }

    // Helper: find all duplicate tag objects (all instances, not just one per duplicate)
    function getAllDuplicateTagObjects(tagdetails, deviceId) {
        const idMap = new Map(); // id -> [tag, ...]
        tagdetails.forEach(tag => {
            if (tag.TagID) {
                const id = deviceId + tag.TagID;
                if (!idMap.has(id)) idMap.set(id, []);
                idMap.get(id).push(tag);
            }
        });
        // Only return arrays with more than one instance (i.e., true duplicates)
        return Array.from(idMap.values()).filter(arr => arr.length > 1).flat();
    }

    // On mount or assetdata change, check for duplicates and block expansion
    useEffect(() => {
        if (!assetdata || !assetdata.devices) return;
        const blocked = [];
        let errorMsg = "";
        // Check for duplicate device IDs
        const dupDeviceIds = findDuplicateDeviceIds(assetdata.devices);
        if (dupDeviceIds.length > 0) {
            errorMsg += `Duplicate Device IDs found: ${dupDeviceIds.join(", ")}. These devices cannot be expanded.\n`;
            assetdata.devices.forEach((device, idx) => {
                if (dupDeviceIds.includes(device.DeviceID)) blocked.push(idx);
            });
        }
        // Check for duplicate tag IDs within each device
        assetdata.devices.forEach((device, idx) => {
            if (Array.isArray(device.tagdetails)) {
                const dupTags = getAllDuplicateTagObjects(device.tagdetails, device.DeviceID);
                if (dupTags.length > 0) {
                    const tagNames = dupTags.map(tag => showAlias ? tag.Alias : tag.TagName).join(", ");
                    errorMsg += `Device '${device.DeviceName}' has duplicate Tag Names: ${tagNames}. This device cannot be expanded.\n`;
                    blocked.push(idx);
                }
            }
        });
        setBlockedDeviceIndexes(blocked);
        if (errorMsg) {
            setDialogMsg(errorMsg);
            setDialogOpen(true);
        } else {
            setDialogOpen(false);
            setDialogMsg("");
        }
    }, [assetdata, showAlias]);

    // Handle checkbox toggle
    // const fetchconfigdeviceIdTagnamecallback = (res) => {
    //     if(res.data.data.length>0){
    //         setExistingDeviceTagAlarmConfig(true)
    //     }else{
    //         setExistingDeviceTagAlarmConfig(false)
    //     }
    // }

    const getdevicetagscallback = (datareceived) =>{
        //console.log("getdevicetagscallback-datareceived",datareceived)
    }

    useEffect(()=>{
        if(userdetails.Projectid == "All"){
            getdevicetagsModified(getdevicetagscallback)
        }else{
            getdevicetagsModified(getdevicetagscallback)
        }
    },[])

    const handleCheck = (event, node, nodeId, devicename,deviceId) => {
        if (checkedNode === nodeId) {
            // If the clicked checkbox is already checked, uncheck it
            setCheckedNode(null);
            setSelectedCheckedNodeName(null);
            setSelectedTag( { projectid:'',tagid:'',tagname : '', tagunit : '', std_tagname: '', tagdatatype:''})
            setSelectedAsset({asset_name:'', device_id:''});
            //setSelectedConfigurationOption('');
            
            
        } else {
            // If another checkbox is clicked, check it and update the state
            var devicetagobject = {
                device_id:deviceId,
                tagname:node["TagName"]
            }
            //fetchconfigdeviceIdTagname(devicetagobject,fetchconfigdeviceIdTagnamecallback)
            setSelectedTag( { projectid:node["ProjectID"],tagid:node["TagID"],tagname : node["Alias"], tagunit : node["Unit"], std_tagname: node["PayloadName"], tagdatatype: node["DataType"]})
            setSelectedAsset({asset_name:devicename, device_id:deviceId});
            setCheckedNode(nodeId);
            setSelectedCheckedNodeName(node["Alias"]); // Assuming `alias` is the name of the tree item
            //setSelectedConfigurationOption('');
           
        }
    };

    const handleMenuItemClick = (menuOption) => {
        //setSelectedConfigurationOption(menuOption);
        setAnchorEl(null);
    }

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };
    const userdetails = useSelector((state) => state.logindata.userdetails)
      
  return (
      <div style={{ width: "310px", marginRight: "0px", marginLeft:"14px", marginBottom:"24px",marginLeft:"24px" }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8, marginLeft: 4 }}>
                <MaterialUISwitch
                    checked={showAlias}
                    onChange={() => {setShowAlias((prev) => !prev); setShowAliasFlag((prev) => !prev);}}
                    inputProps={{ 'aria-label': 'toggle tag alias or name' }}
                />
            </div>
          <Box style={{ border: "1px solid #008CD7", display: 'flex', flexDirection: 'column', height: "360px", padding: '0px 16px', overflowY: "scroll" }}>
              <CustomDialogBox
                    dialogTitle={"Duplicate Tag/Device ID Error"}
                    dialogText={dialogMsg}
                    openDialog={dialogOpen}
                    handleCloseDialog={() => setDialogOpen(false)}
                    handleConfirmDialog={() => setDialogOpen(false)}
                    confirmText={"OK"}
                    type={"Error"}
                />
              { 
             
              assetdata !== null ? (
                  assetdata.hasOwnProperty("devices") ? (
                    Array.isArray(assetdata["devices"]) && assetdata["devices"].length > 0 ? assetdata["devices"].map((objecttreeview, index) => {
                       console.log("Rendering device:", objecttreeview);
                        // Block rendering for devices with duplicate device ID or duplicate tag IDs
                        if (blockedDeviceIndexes.includes(index)) {
                            return (
                                <div style={{ display: "block", opacity: 0.5 }} key={index}>
                                    <Box sx={{ color: 'red', p: 2, fontWeight: 600 }}>
                                        This device cannot be expanded due to duplicate entities.
                                    </Box>
                                </div>
                            );
                        }
                        if(objecttreeview.hasOwnProperty("ProjectID")){
                          if (objecttreeview.hasOwnProperty("DeviceName") && objecttreeview.hasOwnProperty("tagdetails") && Array.isArray(objecttreeview["tagdetails"])  && (objecttreeview["ProjectID"]===userdetails.Projectid || userdetails.Projectid == "All")) {
                              return (
                                  <div style={{ display: "block" }} key={index}>
                                      <SimpleTreeView sx={{
                                                color:themechange === 'light' ? '#3C3C3C' : '#C1C1C1',
                                                '& .MuiTreeItem-content':{
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-start'
                                                },
                                                '& .MuiTreeItem-label':{
                                                    fontSize:'16px',
                                                    fontWeight:400,
                                                    textAlign: 'left',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden'
                                                },
                                            }} defaultCollapseIcon="-" defaultExpandIcon="+">
                                            <TreeItem itemId={objecttreeview["DeviceID"]} label={objecttreeview["DeviceName"]} sx={{'& .MuiTreeItem-label':{
                                                fontSize:'16px',
                                                fontWeight:400,
                                                textAlign: 'left',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden'
                                            },}}>
                                              {Array.isArray(objecttreeview["tagdetails"]) && objecttreeview["tagdetails"].length > 0 ? objecttreeview["tagdetails"].map((tagGroup, index) =>
                                                  renderTreeNodes(tagGroup, handleCheck, checkedNode,objecttreeview["DeviceName"],objecttreeview["DeviceID"],userdetails, showAlias)
                                              ) : <Box sx={{ color: 'var(--SecondaryText)', p: 2, fontWeight: 600 }}>No Tags Found</Box>}
                                          </TreeItem>
                                      </SimpleTreeView>
                                  </div>
                              );
                          } else {
                            return <></>;
                          }
                        }else{
                            <></>;
                        }
                      }) : <Box sx={{ color: 'var(--SecondaryText)', p: 2, fontWeight: 600 }}>No Devices/Tags Found</Box>
                  ) : <></>
              ) : <></>}
              {/* Menu that appears on checkbox selection */}
              <Menu anchorEl={anchorEl} 
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                open={Boolean(anchorEl)} onClose={handleCloseMenu}
                PaperProps={{
                    sx:{
                        backgroundColor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                        borderTop:'2px solid #008CD7',
                        borderBottom:'2px solid #008CD7',
                        borderRadius:0,
                        boxShadow:'none',
                        maxHeight:'250px',
                        overflow:'auto',
                        color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                    }
                }}>
                    <MenuItem onClick={()=> handleMenuItemClick('Conditional Alarms')}>Conditional Alarms</MenuItem>
                    <MenuItem onClick={()=> handleMenuItemClick('Equal Alarms')}>Equal Alarms</MenuItem>
                    <MenuItem onClick={()=> handleMenuItemClick('Ranges Alarms')}>Ranges Alarms</MenuItem>
              </Menu>

          </Box>
      </div>
  );
};

export default AssetTagsRetrievalModified;

